import { getCookie } from "./cookies";
import utils from "./utils";

export function addUTMToDictionary(params) {
  try {
    const updatedParams = params || {};
    const source = getCookie("yc_utm_source");
    const medium = getCookie("yc_utm_medium");
    const campaign = getCookie("yc_utm_campaign");
    const group = getCookie("yc_utm_group");
    const term = getCookie("yc_utm_term");
    const content = getCookie("yc_utm_content");
    const googleClickId = getCookie("yc_google_click_id");
    const gaClientId = getCookie("yc_google_client_id");

    // We also want to track some info about what url etc this person used to signup
    updatedParams.path = window.location.pathname;
    updatedParams.url = window.location.href;

    //const gaCookieId = getCookie('_ga');

    let anonymousId = undefined;
    try {
      if (analytics) {
        anonymousId = analytics.user().anonymousId();
      }
    } catch (e) {}
    if (source) {
      updatedParams.utmSource = source;
    }
    if (medium) {
      updatedParams.utmMedium = medium;
    }
    if (campaign) {
      updatedParams.utmCampaign = campaign;
    }
    if (term) {
      updatedParams.utmTerm = term;
    }
    if (content) {
      updatedParams.utmContent = content;
    }
    if (group) {
      updatedParams.utmGroup = group;
    }
    if (googleClickId) {
      updatedParams.googleClickId = googleClickId;
    }
    if (anonymousId) {
      updatedParams.anonymousId = anonymousId;
    }
    if (gaClientId) {
      console.log("ga", gaClientId);
      updatedParams.gaClientId = gaClientId;
    } else {
      try {
        if (window) {
          updatedParams.gaClientId = window.ga.getAll()[0].get("clientId");
        }
      } catch (e) {
        console.log("ga - not found");
      }
    }

    // if (gaClientId) {
    //   updatedParams.gaClientId = gaClientId;
    // } else {
    //
    // }

    return updatedParams;
  } catch (e) {
    console.log(e);
    return params;
  }
}

/** this is called whenever we want to track an event to segment or any other tracking tool we make use of*/
export function track(event, params) {
  if (utils.isClient() && window.analytics) {
    window.analytics.ready(() => {
      window.analytics.track(event, params);
    });
  }
}

/** this is called when a user identifies themselves as a yoco user to tell segment their identity*/
export function identify(uuid, email) {
  if (!utils.isClient() && window.analytics) {
    window.analytics.identify(uuid);
  }
}



// WEBPACK FOOTER //
// ./src/libs/analytics.js